module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "id": "loading-screen"
    }
  }, [_c('div', {
    staticClass: "fancy-loader"
  }, [_c('span', [_vm._v("LOADING")]), _vm._v(" "), _c('svg', {
    staticClass: "lds-comets",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "250px",
      "height": "250px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(162.228 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "values": "360 50 50;240 50 50;120 50 50;0 50 50",
      "keyTimes": "0;0.333;0.667;1",
      "dur": "1s",
      "keySplines": "0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#41918E",
      "d": "M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E0E0E0",
      "d": "M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#80CBC4",
      "d": "M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-12"
  }, [_c('div', {
    attrs: {
      "data-intro": "<b>Not Available on Help page</b><p>To play the tour guide, click on MSDAT platform and select the tour guide</p>"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Back to platform'),
      expression: "'Back to platform'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "back-to-car-icon",
    on: {
      "click": _vm.navigateToCentralAnalytics
    }
  }, [_c('v-icon', {
    staticClass: "back-to-car-icon-v",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1)])]), _vm._v(" "), _c('h1', {
    staticClass: "help_subtitle "
  }, [_vm._v("Help")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle my-3 "
  }, [_vm._v("Help to Use the Multi-Source Data Analytics & Triangulation (MSDAT) Platform")]), _vm._v(" "), _c('div', {
    staticClass: "text-center align-items-middle my-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "search-box",
    attrs: {
      "type": "text",
      "placeholder": "Search Help by typing a keyword..."
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.filterText), function(i, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "help-title",
      on: {
        "click": function($event) {
          i.show = !i.show
        }
      }
    }, [_c('span', {
      staticClass: "help-title-text"
    }, [_vm._v("\n        " + _vm._s(i.title) + "\n        "), _c('v-icon', {
      staticStyle: {
        "float": "right",
        "color": "white",
        "cursor": "pointer"
      },
      attrs: {
        "medium": ""
      }
    }, [_vm._v(_vm._s(i.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i.show),
        expression: "i.show"
      }],
      staticClass: "help-text"
    }, [(i.isArray === true) ? _c('div', [_c('ul', _vm._l((i.steps), function(steps, count) {
      return _c('li', {
        key: count,
        staticClass: "helpList",
        domProps: {
          "innerHTML": _vm._s(steps)
        }
      })
    }))]) : _c('div', _vm._l((i.steps), function(key, counter) {
      return _c('div', {
        key: counter
      }, [_c('p', {
        staticStyle: {
          "margin-top": "20px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(counter.replace('_', ' ')))]), _vm._v(" "), _c('ul', _vm._l((key), function(steps, count) {
        return _c('li', {
          key: count,
          staticClass: "helpList"
        }, [_vm._v(_vm._s(steps))])
      }))])
    }))])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "-20px !important"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "faq_subtitle",
    staticStyle: {
      "margin-top": "-40px !important"
    },
    attrs: {
      "id": "faq"
    }
  }, [_vm._v("Frequently Asked Questions (FAQs)")]), _vm._v(" "), _c('div', {
    staticClass: "faq_sub "
  }, [_vm._v("Answers to some Frequently Asked Questions (FAQs) about MSDAT Platform.")]), _vm._v(" "), _vm._l((_vm.faqArray), function(i, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "help-title",
      on: {
        "click": function($event) {
          i.show = !i.show
        }
      }
    }, [_c('span', {
      staticClass: "help-title-text"
    }, [_vm._v("\n        " + _vm._s(i.title) + "\n        "), _c('v-icon', {
      staticStyle: {
        "float": "right",
        "color": "white",
        "cursor": "pointer"
      },
      attrs: {
        "medium": ""
      }
    }, [_vm._v(_vm._s(i.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i.show),
        expression: "i.show"
      }],
      staticClass: "help-text"
    }, [_c('ul', [_c('li', {
      staticClass: "helpList",
      domProps: {
        "innerHTML": _vm._s(i.ans)
      }
    })])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box row my-4 "
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-12 pr-0 pl-4",
    staticStyle: {
      "padding-left": "50px !important"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "alt": "FAQ Icon",
      "src": require("../../../../../static/img/faq.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pl-0  col-md-8  col-sm-12"
  }, [_c('strong', [_vm._v("Got questions?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bolder"
    }
  }, [_vm._v("See answers to some Frequently Asked Questions (FAQs) about the MSDAT Platform.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2  col-sm-12"
  }, [_c('button', {
    staticClass: "btn text-light",
    staticStyle: {
      "border": "none",
      "width": "110px !important"
    }
  }, [_c('a', {
    attrs: {
      "href": "#faq"
    }
  }, [_vm._v(" See FAQs")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47a214bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/mainCar/car_help.vue
// module id = 963
// module chunks = 7